
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"64","height":"64","fill":"#3D2562","rx":"8.258"}}),_c('path',{attrs:{"fill":"#FFF","d":"M43.824 18.839H20.176a2.638 2.638 0 00-2.628 2.632v15.794a2.638 2.638 0 002.628 2.632h9.196v2.632H28.06a1.315 1.315 0 100 2.632h7.882c.726 0 1.314-.589 1.314-1.316 0-.727-.588-1.316-1.314-1.316h-1.313v-2.632h9.196a2.638 2.638 0 002.628-2.632V21.47a2.638 2.638 0 00-2.628-2.632zM42.51 37.265H21.49c-.726 0-1.314-.59-1.314-1.317v-13.16c0-.728.588-1.317 1.314-1.317h21.02c.726 0 1.314.59 1.314 1.316v13.161c0 .727-.588 1.317-1.314 1.317z"}})])])
          )
        }
      }
    